import React from "react";
import RecentChatItem from "./RecentChatItem";

const RecentChat = (props = {}) => {
  const getMessageInfo = (recentChatItem) => {
    const { recent: { msgId, fromUserId } = {} } = recentChatItem;
    return {
      msgId,
      fromUserId,
    };
  };

  const {
    pageType = "recent",
    recentChatItems,
    searchTerm,
    messageData,
    recentChatExist,
    archiveLength=0,
    callUserJID,
    callType,
    callMode,
    callStatus,
    handleShowCallScreen,
    handlePopupState
  } = props;
  if (recentChatItems.length === 0) return null;
  const searchLen = searchTerm && searchTerm.trim().length;
  const isArchivePage = pageType === "recent" ? 0 : 1;
  const filteredItems = !searchLen
    ? recentChatItems.filter(
        (item) => item?.recent?.archiveStatus === isArchivePage
      )
    : recentChatItems;
  return (
    <React.Fragment>
      {searchLen > 0 && recentChatExist && (
        <div className="search-head">Chats</div>
      )}
      <ul
        className="chat-list-ul"
        style={{
          display: `${
            archiveLength === 0 && pageType === "archive" ? "none" : ""
          }`,
        }}
      >
        {filteredItems.map((recentChatItem, key) => {
          const { msgId, fromUserId } = getMessageInfo(recentChatItem);
          const { hidden = false } = recentChatItem;
          const {
            roster: { isAdminBlocked = "" },
          } = recentChatItem;
          return (
            <RecentChatItem
              pageType={pageType}
              enableDropDown={true}
              key={fromUserId}
              hidden={hidden}
              activeClass={false}
              messageId={msgId}
              searchTerm={searchTerm}
              messageData={messageData}
              item={recentChatItem}
              handleShowCallScreen={handleShowCallScreen}
              isAdminBlocked={isAdminBlocked}
              callUserJID = {callUserJID}
              callStatus={callStatus}
              callType={callType}
              callMode={callMode}
              handlePopupState={handlePopupState}
            />
          );
        })}
      </ul>
    </React.Fragment>
  );
};
export default RecentChat;
